<template>
  <section class="page-error">
    <header v-if="showHeader">
      <header-app
        :is-mobile="isMobile"
      />
    </header>
    <main class="page-error__wrapper">
      <dropdown :invert-color="false" :defaultValue="$t('cardForm.language.short')"
                v-if="!showHeader && showLang">
        <b-dropdown-item
            :active="currentLanguage === 'ru'"
            link-class="authentication__dropdown-item_lang"
            @click="setLocale('ru')"
        >
          {{ $t('cardForm.language.russian') }}
        </b-dropdown-item>
        <b-dropdown-item
            :active="currentLanguage==='en'"
            link-class="authentication__dropdown-item_lang"
            @click="setLocale('en')"
        >
          {{ $t('cardForm.language.english')}}
        </b-dropdown-item>
      </dropdown>
      <div class="page-error__content">
        <img class="page-error__pic" src="../../assets/img/404.svg" alt="">
        <h4 class="page-error__title">
          <slot name="title" />
        </h4>
        <p class="page-error__message">
          <slot name="message" />
        </p>
        <slot />
      </div>
    </main>
  </section>
</template>

<script>
import { SET_LANGUAGE } from '@/store/app/types';
import HeaderApp from '../HeaderApp/HeaderApp';
import Dropdown from '../../components/Dropdown/Dropdown';

export default {
  name: 'PageError',
  components: {
    HeaderApp,
    Dropdown,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    showLang: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    basicInfo() {
      return this.$store.getters.basicInfo;
    },
    currentLanguage() {
      return this.$store.state.app.currentLanguage;
    },
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$moment.locale(locale);
      this.$store.dispatch(SET_LANGUAGE, locale);
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-error {
    background-color: #FFFFFF;
    min-height: 100vh;
  }
  .page-error__wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 10% 32px;
    align-items: flex-end;
  }
  .page-error__content {
    margin: auto;
  }
  .page-error__pic {
    max-width: 80%;
    height: auto;
  }
  .page-error__title {
    margin-top: 7%;
    font-weight: bold;
  }
  .page-error__message {
    margin-top: 1%;
  }
  .btn-app {
    margin: 25px auto 0;
    min-width: 250px;
    padding: 0 1.5em;
    width: max-content;
  }
  @media screen and (max-width: $breakpoint-sm) {
    .page-error__wrapper {
      padding: 15% 32px;
    }
  }
</style>
